export interface EnvironmentModel {
  qualtricsAlwaysOnFeedbackEnabled: boolean;
  featureAnnouncementRetentionMonths: number;
  api: string;
  apimKey: string;
  appInsights?: {
    instrumentationKey: string;
  };
  authApiUrl: string;
  baseUrl: string;
  certificateGraphqlHost: string;
  contactGraphqlHost: string;
  dnvLink?: string;
  documentsApi: string;
  federatedLogoutUrl: string;
  findingGraphqlHost: string;
  invoicesGraphqlHost: string;
  auditGraphqlHost: string;
  production: boolean;
  scheduleGraphqlHost: string;
  veracityUrl: string;
  notificationGraphqlHost: string;
  lmsUrl: string;
  serviceNow: ServiceNowEnvironmentModel;
  cacheDuration?: number;
  trainingLink: string;
  translation: {
    baseUrl: string;
    SAS: string;
    useLocalTranslations?: boolean;
  };
  maintenance: {
    blobUrl: string;
    functionsBaseUrl: string;
    signalRNegotiateUrl: string;
    apimSubscriptionMaintenanceKey: string;
  };
}

export interface ServiceNowEnvironmentModel {
  moduleId: string;
  scriptUrl: string;
  sysIds: {
    catalogItem: string;
    dnvInvoice: string;
    dnvSchedule: string;
    dnvCertificate: string;
    dnvCompanySettings: string;
    dnvReschedule: string;
  };
}
